export default __webpack_public_path__ + "static/media/dp.05071430.svg";